<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<!-- <h4>筛选查询</h4> -->
					<el-row>
						<el-col :span="20">
							<el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
							<!-- <el-form-item label="一级分类">
								<el-select clearable v-model="form.one" placeholder="一级分类" @change="getOne">
									<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listOne" :key="item.id">{{item.columname}}</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="二级分类" size="mini" v-show="twoShow">
								<el-select clearable v-model="form.two" placeholder="二级分类" @change="getTwo">
									<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listTwo" :key="item.id">{{item.columname}}</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="三级分类" size="mini" v-show="threeShow">
								<el-select clearable v-model="form.three" placeholder="三级分类">
									<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listThree" :key="item.id">{{item.columname}}</el-option>
								</el-select>
							</el-form-item> -->
							<el-form-item label="标题">
								<el-input v-model="form.title"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="getData">查询</el-button>
								<el-button type="danger" @click="clear">清空</el-button>
							</el-form-item>
							<el-form-item>
								<button class="addAll" @click="update('add')">新增内容</button>
							</el-form-item>
							</el-form>
						</el-col>
						<el-col :span="2"></el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-table  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
							 element-loading-background="rgba(0, 0, 0, 0.8)" size="mini" ref="multipleTable" :data="tableData" style="width: 100%" border :header-cell-style="{background:'#E5E7EE',color:'#000000'}">
								<el-table-column type="selection" width="55" align="center">
								</el-table-column>
								<el-table-column prop="id" label="编号" align="center" width="55">
								</el-table-column>
								<el-table-column prop="title" label="标题" align="center">
								</el-table-column>
								<el-table-column prop="must" label="必填" align="center">
								<template slot-scope="scope">
									<el-switch @change="updateStatus(scope.$index,scope.row)" :active-value="1" :inactive-value="0" v-model="scope.row.must" active-color="#13ce66" inactive-color="#dcdfe6">
									</el-switch>
								</template>
								</el-table-column>
								<el-table-column prop="addTime" label="更新时间" align="center">
								</el-table-column>
								<el-table-column fixed="right" label="操作">
									<template slot-scope="scope">
									<!-- 	<el-button @click.native.prevent="update('update',scope.row)" type="text" size="small">
											编辑
										</el-button>
										<span>|</span>
										<el-button @click.native.prevent="deleteRow(scope.row)" type="text" size="small">
											删除
										</el-button> -->
										<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
											<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
										
									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
								<button class="selectAll" @click="toggleSelection(tableData)">全选</button>
								<button class="del" @click="selectDel">批量删除</button>
							</div>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
							 :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
				form: {
					// one: '',
					// two: '',
					// three: ''
					title:''
				},
				tableData: [
				],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				multipleTable: [],
				listOne: [],
				listTwo: [],
				listThree: [],
				loading:false,
					twoShow:false,
					threeShow:false
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
		methods: {
			clear() {
				this.form.title = ''
				this.getData(this.currentPage, this.pageSize)
			},
			getData(currentPage, pageSize) {
				this.loading = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v2/goods/parameter/page',
					params: {
 cid:this.$route.query.id,
						roof: '',
						title: this.form.title,
						status: '',
						pageNum: currentPage,
						pageSize: pageSize,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//获取分类
			getType() {
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/one',
					params: {
 
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listOne = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getOne(event) {
				this.twoShow = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/child',
					params: {
 
						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listTwo = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getTwo(event) {
				this.threeShow = true
				this.form.three = ''
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/child',
					params: {
 
						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listThree = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			//修改
			update(iden, rows) {
				this.$router.push({
					path: '/home/parameterUpdate',
					query: {
						iden: iden,
						rows: rows,
						id:this.$route.query.id
					}
				})
			},
			deleteRow( rows) {
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/goods/parameter/delete',
						params: {
							id: rows.id,
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})
				
				}).catch(() => {
					this.loading = false
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//批量删除
			selectDel() {
			
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/goods/parameter/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})
			
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//修改状态
			updateStatus(index, rows) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/change/must',
					params: {
						id: rows.id,
 
						must: rows.must
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						obj.$message.success('修改成功')
						this.getData(this.currentPage, this.pageSize)
					} else {
						this.loading = false
						obj.$message.error(res.data.message)
					}
				})
			},
		},
	}
</script>

<style scoped="scoped">
	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
	}

	/deep/ .el-button--text {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}
	h4{
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/commodity/parameters.vue